package com.milta.core.localization.translations.pl

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "AI",
    menuAiLegend = "AI: automatyczny odczyt przez sztuczną inteligencję, który zużywa Twój kredyt AI. W przypadku Excela tylko wtedy, gdy kolumny nie zostaną rozpoznane.",
    menuExhaustedTitle = "Kredyt AI wyczerpany — reset {date}.",
    menuExhaustedMessage = "Skanowanie i import PDF są wyłączone. Arkusz z oczekiwanymi kolumnami i wprowadzanie ręczne pozostają dostępne.",
    modeDisabledReason = "Kredyt AI wyczerpany",
    exhaustedBannerWebTitle = "Kredyt AI wyczerpany — reset {date}.",
    exhaustedBannerWebMessage = "Plików PDF nie można już analizować. Zaimportuj plik Excel lub CSV z oczekiwanymi kolumnami albo dodaj dostawy ręcznie w aplikacji mobilnej.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) lub CSV · maks. 500 przystanków · 10 MB",
    pdfUnavailableUntil = "PDF niedostępny do {date}",
    pdfRefusedTitle = "Kredyt AI wyczerpany — tego pliku PDF nie można przeanalizować",
    pdfRefusedMessage = "„{file}” wymaga odczytu przez AI. Twój kredyt wróci {date}. Do tego czasu zaimportuj plik Excel lub CSV z oczekiwanymi kolumnami albo dodaj dostawy ręcznie w aplikacji mobilnej.",
    spreadsheetExhaustedTitle = "Nierozpoznane kolumny — kredyt AI wyczerpany",
    spreadsheetExhaustedWebMessage = "Kolumny pliku „{file}” nie odpowiadają oczekiwanym kolumnom, a Twój kredyt AI nie pozwala już na ich automatyczne dopasowanie (powrót {date}). Zmień nazwy kolumn jak poniżej albo dodaj dostawy ręcznie w aplikacji mobilnej.",
    expectedColumnsNoCreditHint = "Plik zgodny z tymi kolumnami jest importowany bez AI i nie zużywa kredytu, nawet przy 0%.",
    importExhaustedTitle = "Kredyt AI wyczerpany",
    importExhaustedPhotoMessage = "Twój kredyt AI spadł do 0%, gdy ten import czekał. Zdjęcie nie zostało przeanalizowane i nic nie zostało naliczone. Reset {date}.",
    importExhaustedFileMessage = "Twój kredyt AI spadł do 0%, gdy ten import czekał. Plik nie został przeanalizowany i nic nie zostało naliczone. Reset {date}.",
    importSpreadsheetExhaustedMessage = "Kolumny tego pliku nie odpowiadają oczekiwanym kolumnom, a Twój kredyt AI nie pozwala już na ich automatyczne dopasowanie. Reset {date}.",
    stepPhotoSent = "Zdjęcie wysłane",
    stepFileSent = "Plik wysłany: {file}",
    stepAnalysisNotStarted = "Analiza nieuruchomiona: kredyt AI wyczerpany",
    stepFileRead = "Plik odczytany: {file}",
    stepExpectedColumns = "Oczekiwane kolumny: Nazwa odbiorcy, Pełny adres",
    stepDeliveriesKept = "Wprowadzone już dostawy zostają zachowane",
    retryAvailableOn = "Spróbuj ponownie — dostępne {date}",
    manualEntryAction = "Wprowadzanie ręczne",
    myUsageTitle = "Moje zużycie",
    myUsageAttachedDriverNote = "Widoczne są tu tylko Twoje własne działania. To, co firmy uruchamiają dla Ciebie, jest liczone po ich stronie.",
    tabOptimizations = "Optymalizacje",
    tabAiCredit = "Kredyt AI",
    remainingForPeriod = "Pozostały kredyt AI w tym okresie",
    percentValue = "{percent}%",
    remainingSuffix = "pozostałego kredytu AI",
    lowPill = "Niski kredyt",
    exhaustedPill = "Wyczerpany · skanowanie i import PDF wyłączone",
    driverNote = "Twój kredyt wraca przy odnowieniu subskrypcji (subskrypcji Twojej Firmy, jeśli do niej należysz). Niewykorzystany kredyt nie przechodzi na kolejny okres.",
    enterpriseNote = "Wraca przy odnowieniu subskrypcji, bez przenoszenia. Ten kredyt dotyczy tylko Twoich działań AI; każdy kierowca ma własny.",
    exhaustedNote = "Wprowadzanie ręczne i arkusze z oczekiwanymi kolumnami pozostają dostępne. Kredyt wraca przy odnowieniu subskrypcji.",
    webScopeHint = "Ten kredyt dotyczy tylko działań AI tego konta: skanów, importów PDF lub zdjęć, nierozpoznanych kolumn arkusza. Każdy kierowca ma własny.",
    profileValue = "{optimizations} · AI {percent}%",
    profileValueAiOnly = "AI {percent}%",
    columnShare = "Udział w kredycie",
    actionScanDeliveryList = "Skan listy",
    actionScanPackageLabel = "Skan etykiety",
    actionImportPdf = "Import PDF",
    actionImportUnstructured = "Import w tle",
    actionSpreadsheetMapping = "Kolumny arkusza (AI)",
    outcomeSuccess = "Udane",
    outcomeFailed = "Nieudane",
    outcomeUnreadable = "Nieczytelne",
    countedSuffix = "(naliczone)",
    rowDateTime = "{date} o {time}",
    limitsEyebrow = "Kredyt AI na okres",
    limitsDescription = "Kwota w euro, jaką każde konto może wykorzystać na wywołania AI (skany, importy PDF lub zdjęć, nierozpoznane kolumny arkusza) w okresie subskrypcji. Kredyt wraca do limitu przy odnowieniu subskrypcji, bez przenoszenia.",
    weightedEquivalent = "≈ {tokens} tokenów ważonych",
    limitsFootnote = "Kierowca Firmy otrzymuje limit „Kierowca”, próbny dopóki jego Firma jest w okresie próbnym. Ekwiwalent w tokenach jest orientacyjny i przeliczany według poniższego kursu.",
    conversionEyebrow = "Przeliczenie i alert",
    rateLabel = "Kurs wymiany",
    rateHint = "Aktualizowany ręcznie · dotyczy kolejnych wywołań",
    thresholdLabel = "Alert niskiego kredytu",
    thresholdUnit = "% pozostało",
    thresholdHint = "Procent na pomarańczowo i baner raz na okres",
    calculationTitle = "Jak obliczany jest koszt wywołania.",
    calculationBody = "Claude Haiku 4.5: 1 $ za milion tokenów wejściowych, 5 $ za milion tokenów wyjściowych. Token ważony = wejście × 1 + wyjście × 5, więc 1 $ = 1 000 000 tokenów ważonych. Koszt w euro = koszt w dolarach ÷ kurs. Przykład: przeciętny skan listy (5 014 wejście + 1 792 wyjście) = 13 974 tokenów ważonych = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Limity zapisane.",
    settingsSavedDetail = "Firma: {enterpriseTrial} próbny · {enterprisePaid} płatny. Kierowca: {driverTrial} próbny · {driverPaid} płatny. Kurs {rate}. Alert {threshold}%.",
    limitTooHigh = "Maksymalnie 1 000 €.",
    rateTooHigh = "Maksymalnie 10.",
    thresholdOutOfRange = "Od 1 do 99.",
    adminCreditTitle = "Kredyt AI",
    adminRemainingLine = "≈ {tokens} pozostałych tokenów ważonych · zużyto {consumed}",
    adminOverrunLine = "Zużyto {consumed} · przekroczenie o {over}",
    adminLowPill = "Niski kredyt · poniżej {threshold}%",
    adminLowPillNoThreshold = "Niski kredyt",
    adminExhaustedPill = "Kredyt wyczerpany · działania AI wyłączone",
    adminAppliedAfterReplacement = "{consumed} zużyte + {remaining} pozostałe (zastąpienie)",
    adminGlobalLimitLabel = "Limit globalny",
    adminGlobalLimitResumes = "{source} — obowiązuje ponownie od resetu",
    adminResetNoCarryOver = "Zaczyna od {limit}: przekroczenie nie jest przenoszone",
    replaceLabel = "Zastąp pozostały kredyt",
    replaceHelp = "Od 0 do 100 €, tylko dla bieżącego okresu. Przy resecie konto zaczyna ponownie od limitu globalnego.",
    replaceHelpEnterpriseDriver = "Zmienia tylko kredyt {name}. Kredyt Firmy i innych kierowców się nie zmienia.",
    replaceInvalid = "Wprowadź kwotę od 0 do 100 €.",
    replacedTitle = "Pozostały kredyt zastąpiony: {from} → {to}.",
    replacedDetail = "Na bieżący okres. {date} powrót do limitu globalnego ({limit}).",
    adminHistoryTitle = "Historia kredytu AI",
    adminPeriodSummary = "Bieżący okres od {start}: {calls} wywołań · {failed} nieudanych lub nieczytelnych (naliczonych) · {tokens} tokenów ważonych · {consumed}",
    columnInput = "Wejście",
    columnOutput = "Wyjście",
    columnWeighted = "Ważone",
    columnCost = "Koszt",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Twój kredyt AI jest wyczerpany. Plik nie został przeanalizowany i nic nie zostało naliczone. Reset {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
